exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@-webkit-keyframes blink{0%{opacity:1}50%{opacity:0}}@keyframes blink{0%{opacity:1}50%{opacity:0}}", ""]);

